import React, { useEffect, useState } from 'react';
import logoImg from '@/assets/m/icon-hkzk.png';
import androidImg from '@/assets/m/android.png';
import iosImg from '@/assets/m/ios.png';
import './index.css';

const DownloadPage = (props) => {
  useEffect(() => {
    document.title = '鸿凯瑞达-App下载';
  }, []);

  const goDownLoadApp = () => {
    const link = document.createElement('a');
    link.href = `http://www.hongkairuida.com/%E9%B8%BF%E5%87%AF%E6%99%BA%E6%8E%A7.apk`; // 替换为你的APK文件路径
    link.download = '鸿凯智控APP.apk'; // 下载时保存的文件名
    link.click();
  };

  const goDownLoadAppIOS = () => {
    const iosAppStoreUrl = 'https://apps.apple.com/cn/app/6745921454';
    window.location.href = iosAppStoreUrl;
  };
  return (
    <div className="page-all">
      <div className="dow-page-hkzk">
        <img src={logoImg} alt="" className="logoimg" />
        <div className="logoname">鸿凯智控</div>
        <div className="logotips">开启便捷智能生活</div>

        <div className="btm-dowbtn" onClick={() => goDownLoadApp()}>
          <img src={androidImg} alt="" />
          <div>Android 下载</div>
        </div>

        <div className="btm-dowbtn-ios" onClick={() => goDownLoadAppIOS()}>
          <img src={iosImg} alt="" />
          <div>IOS 下载</div>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
